import { render } from "./VFooter.vue?vue&type=template&id=42d6655a&scoped=true"
import script from "./VFooter.vue?vue&type=script&lang=js"
export * from "./VFooter.vue?vue&type=script&lang=js"

import "./VFooter.vue?vue&type=style&index=0&id=42d6655a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42d6655a"]])

export default __exports__